/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-09-12 07:52:41
 *
 *******************************************************/
// @flow

import React, { Component } from 'react';
import Nouislider from 'nouislider-react';
import 'nouislider/distribute/nouislider.css';

import plans from 'src/constants/plans.json';
import plansPlus from 'src/constants/plans-plus.json';
import plansOld from 'src/constants/plans-old.json';

type Props = {
  products: number,
  onSlide: Function
};

class PriceSlider extends Component<Props> {
  state = {};

  componentDidMount() {
    const { allowToSubscribePlanV1 } = this.props;

    // Tip & trick (!)
    // Append custom label and icons after rendering of slider
    setTimeout(function() {
      // Add class to the last ui maker
      const noUiPips = document.getElementsByClassName('noUi-marker-large');
      if (noUiPips.length > 0) {
        const lastElement = noUiPips[noUiPips.length - 1];
        lastElement.classList.remove('noUi-marker-large');
        lastElement.classList.remove('noUi-marker');
        lastElement.classList.add('noUi-marker-large-last');
      }

      // Max product label
      // const noUiOrigin = document.getElementsByClassName('noUi-origin');
      // noUiOrigin[0].insertAdjacentHTML(
      //   'afterbegin',
      //   '<div className="noUiMaxProductLabel">Max product</div>'
      // );

      const noUiValues = document.getElementsByClassName('noUi-value-large');
      if (noUiValues.length > 0) {
        // Insert marker for the price of 2500, 7500, 12500
        const insertValues = allowToSubscribePlanV1 ? [4.55, 13.64, 22.73] : [4.55, 13.64]; // Percent
        for (let i = 0; i < insertValues.length; i++) {
          // Insert marker for the price of 2500
          noUiValues[i].insertAdjacentHTML(
            'afterend',
            `<div class="noUi-marker noUi-marker-horizontal noUi-marker-large" style="left: ${insertValues[i]}%;"></div>`
          );
        }
      }

      // Icon for Slide button
      const noUiButton = document.getElementsByClassName('noUi-handle-lower');
      if (noUiButton && noUiButton[0]) {
        noUiButton[0].insertAdjacentHTML(
          'afterbegin',
          '<div class="noUiButton"><span class="Polaris-Icon Polaris-Icon--colorWhite"><svg viewBox="0 0 20 20" class="Polaris-Icon__Svg" focusable="false" aria-hidden="true"><path d="M12 16a.997.997 0 0 1-.707-.293l-5-5a.999.999 0 0 1 0-1.414l5-5a.999.999 0 1 1 1.414 1.414L8.414 10l4.293 4.293A.999.999 0 0 1 12 16" fill-rule="evenodd"></path></svg></span><span class="Polaris-Icon Polaris-Icon--colorWhite"><svg viewBox="0 0 20 20" class="Polaris-Icon__Svg" focusable="false" aria-hidden="true"><path d="M8 16a.999.999 0 0 1-.707-1.707L11.586 10 7.293 5.707a.999.999 0 1 1 1.414-1.414l5 5a.999.999 0 0 1 0 1.414l-5 5A.997.997 0 0 1 8 16" fill-rule="evenodd"></path></svg></span></div>'
        );
      }
    }, 500);
  }

  render() {
    const { products, allowToSubscribePlanV1 } = this.props;
    return (
      <div className="priceSlider">
        <Nouislider
          start={[products]}
          connect={'lower'}
          pips={{
            mode: 'values',
            values: [
              1000,
              5000,
              10000,
              15000,
              20000,
              25000,
              30000,
              35000,
              40000,
              45000,
              50000,
              55000
            ],
            density: 7,
            format: {
              // 'to' the formatted value. Receives a number.
              to: function(value) {
                const string = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                return string === '55,000' ? '50,000+' : string;
              },
              // 'from' the formatted value.
              // Receives a string, should return a number.
              from: function(value) {
                value = value === '50,000+' ? '55,000' : '';
                return Number(value.replace(',', ''));
              }
            }
          }}
          clickablePips
          range={
            allowToSubscribePlanV1
              ? {
                  min: [1000, 1500],
                  '4.55%': [2500, 2500],
                  '9.09%': [5000, 2500],
                  '13.64%': [7500, 2500],
                  '18.18%': [10000, 2500],
                  '22.73%': [12500, 2500],
                  '27.27%': [15000, 5000],
                  '36.36%': [20000, 5000],
                  '45.45%': [25000, 5000],
                  '54.55%': [30000, 5000],
                  '63.64%': [35000, 5000],
                  '72.73%': [40000, 5000],
                  '81.82%': [45000, 5000],
                  '90.91%': [50000, 5000],
                  max: [55000]
                }
              : {
                  min: [1000, 1500],
                  '4.55%': [2500, 2500],
                  '9.09%': [5000, 2500],
                  '13.64%': [7500, 2500],
                  '18.18%': [10000, 5000],
                  // '22.73%': [12500, 2500],
                  '27.27%': [15000, 5000],
                  '36.36%': [20000, 5000],
                  '45.45%': [25000, 5000],
                  '54.55%': [30000, 5000],
                  '63.64%': [35000, 5000],
                  '72.73%': [40000, 5000],
                  '81.82%': [45000, 5000],
                  '90.91%': [50000, 5000],
                  max: [55000]
                }
          }
          animate={true}
          animationDuration={300}
          onSlide={this.onSlide}
        />
      </div>
    );
  }

  // Get plan based on selected product count
  onSlide = (render, handle, value, un, percent) => {
    const { subscribePlusPlanV2, allowToSubscribePlanV1 } = this.props;

    const products = value[0];
    let plan = {};

    // If select a large plan
    if (products === 55000) {
      plan = { name: 'large' };
    } else {
      // Get selected plan
      const plansList = allowToSubscribePlanV1 ? plansOld : subscribePlusPlanV2 ? plansPlus : plans;
      Object.keys(plansList).map(key => {
        if (plansList[key].products === products) {
          plan = plansList[key];
        }

        return key;
      });
    }

    this.props.onSlide(plan);
  };
}

export default PriceSlider;
